export enum LinkResourceStyle {
    Default = "__default",
    MetaNav = "__metanav",
}
